import styled from "styled-components";
import { PRIMARY_COLOR, SECOND_COLOR } from "utils/const";

export const LinksTermsContainer = styled.aside`
  .item-links {
    list-style: none;
    font-size: 1.6rem;
    margin-bottom: 8px;
    color: ${PRIMARY_COLOR};
  }

  .item-links:hover {
    cursor: pointer;
    color: ${SECOND_COLOR};
  }
`;
